var e4 = e4 || {},
    dcc = dcc || {};
dcc.search = {
    init: function () {
        var jForm = jQuery( '.js-dcc-search-typeahead-form' );
        
        if ( jForm.length > 0 ) {
            dcc.search.populate(jForm);
            e4.util.require.js( e4.settings.require.typeahead, function () {
                dcc.search.bindEvents();
            } );
        }
    },
    populate: function(jSearchForm){
        var populationData = jQuery('.js-search-form-template').data();

        jSearchForm.attr('action', populationData.action)
            .data('defaultValue', populationData.defaultValue);

        jSearchForm.find('.js-dcc-search-typeahead-input').val(populationData.defaultValue).attr('placeholder', populationData.placeholder);

        dcc.search.viewAllText = populationData.viewAllText;
        dcc.search.headerText = populationData.headerText;
        dcc.search.viewAllLink = populationData.viewAllLink;
        dcc.search.discontinuedUrl = populationData.discontinuedDetailsUrl;
        dcc.search.fallbackpage = populationData.fallbackPage;
     },
    bindEvents: function () {
        jQuery( '.js-dcc-search-typeahead-mobile-toggle' ).on( 'click', 'span', function ( event ) {
            event.preventDefault();
            jQuery( '.js-dcc-search-typeahead-mobile-toggle-target' ).toggleClass( 'show' );
        } );
        jQuery( '.js-dcc-search-typeahead-form' ).on( 'click', '.js-dcc-search-submit', function ( event ) {
            jQuery( event.target.form ).trigger( 'submit' );
        } ).find( '.js-dcc-search-typeahead-input' ).on( 'keydown', function ( event ) {
            if ( event.keyCode === 13 ) {
                var jSuggestions = jQuery( event.target.form ).find( '.js-dcc-search-suggestions' ),
                    jSuggestionActive = jSuggestions.find( '.tt-selectable' ).filter( '.active' ),
                    jHeader = jQuery( '.js-dcc-search-group-header' ),
                    jExactProduct = jSuggestions.find( '.js-dcc-search-suggestions-item[data-type="product"]' );
                jHeader.removeClass( 'd-block' );
                if ( jSuggestionActive.length === 0 && jSuggestions.css( 'display' ) === 'block' ) {
                    if ( jHeader.length > 0 ) {
                        jHeader.addClass( 'd-block' );
                        return false;
                    }
                    else {
                        if ( jExactProduct.length === 1 ) {
                            event.preventDefault();
                            jExactProduct.first().trigger( 'click' );
                        }
                        else {
                            if ( dcc.search.query ) {
                                jQuery( event.target.form ).find( '.js-dcc-search-typeahead-input' ).val( dcc.search.query );
                            }
                            jQuery( event.target.form ).trigger( 'submit' );
                        }
                    }
                }
            }
        } ).on( 'focus', function ( event ) {
            dcc.search.placeholderTxt = jQuery( event.target ).attr( 'placeholder' );
            jQuery( event.target ).attr( 'placeholder', '' );
        } ).on( 'blur', function ( event ) {
            jQuery( event.target ).attr( 'placeholder', dcc.search.placeholderTxt );
        } ).typeahead( {
            hint: false,
            highlight: true,
            minLength: 2,
            classNames: {
                wrapper: 'dcc-search-typeahead-wrapper js-dcc-search-typeahead-wrapper w-100 small',
                input: 'js-dcc-search-typeahead-input',
                menu: 'js-dcc-search-suggestions dcc-search-suggestions dropdown-menu ',
                suggestion: 'js-dcc-search-suggestions-item dropdown-item dcc-search-suggestions-item',
                open: 'open',
                cursor: 'active',
                highlight: 'active'
            }
        }, dcc.search.getTypeaheadDatasets() ).on( 'typeahead:autocomplete typeahead:select', function ( event, result ) { // typeahead:cursorchange
            if ( result !== null ) {
                dcc.search.select( result );
                //jQuery( event.target ).typeahead( 'close' );
            }
        } ).on( 'typeahead:active', function ( event ) {
            var strValue = jQuery( event.target ).val();
            if ( strValue.length > 0 ) {
                jQuery( event.target ).val( '' ).val( strValue ).trigger( 'input' );
            }
        } );
        dcc.search.setDefault();
    },
    testForGroup: function ( obj ) {
        return obj.Type === 'group';
    },
    getTypeaheadDatasets: function () {
        return {
            name: 'dcc-products',
            display: function ( suggestion ) {
                return suggestion.Title;
            },
            limit: 8,
            async: true,
            source: function ( query, syncResults, asyncResults ) {
                // console.log( 'source', query, syncResults, asyncResults );
                dcc.search.getSuggestions( query, function ( data ) {
                    asyncResults( data );
                } );
            },
            templates: {
                suggestion: function ( data ) {
                    return '<div class="js-dcc-search-suggestions-item dropdown-item tt-selectable" data-type="' + data.Type + '">' + data.Title + '</div>';
                },
                header: function ( data ) {
                    if ( data.suggestions.some( dcc.search.testForGroup ) === true ) {
                        return '<div class="dcc-search-group-header js-dcc-search-group-header">' + dcc.search.headerText + '</div>';
                    }
                },
                footer: function ( data ) {
                    dcc.search.query = data.query;
                    if ( data.suggestions.every( dcc.search.testForGroup ) === true ) {
                        dcc.search.query = data.suggestions[ 0 ].Terms;
                    }
                    if ( data.suggestions.length === 1 ) {
                        return '<div class="dropdown-divider"></div><div class="js-dcc-search-suggestions-item dropdown-item tt-selectable"><a class="view-all-link js-view-all-link" href="' + data.suggestions[ 0 ].Url + '">' + dcc.search.viewAllText + ' ' + data.query + '</a></div>';
                    }
                    return '<div class="dropdown-divider"></div><div class="js-dcc-search-suggestions-item dropdown-item tt-selectable"><a class="view-all-link js-view-all-link" href="' + dcc.search.viewAllLink + encodeURIComponent( dcc.search.query ) + '">' + dcc.search.viewAllText + ' ' + data.query + '</a></div>';
                }
            }
        };
    },
    getSuggestions: function ( query, asyncResults ) {
        if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
            this.jqXHR.abort();
        }
        query = jQuery.trim( query );
        if ( query !== '' ) {
            this.jqXHR = jQuery.ajax( {
                type: 'GET',
                url: '/dccquery',
                data: { terms: query },
                dataType: 'json'
            } );
            this.jqXHR.done( function ( data ) {
                var productUrl = '',
                    json = {
                        suggestions: []
                    };
                if ( data.Groups.length === 1 ) {
                    productUrl = dcc.search.viewAllLink + encodeURIComponent( data.Terms );
                }
                jQuery.each( data.Groups, function ( intIndex, objElement ) {
                    if ( json.suggestions.length < 8 ) {
                        json.suggestions.push( {
                            Title: objElement.Name + ' (' + objElement.Count + ')',
                            Url: objElement.PageQuery,
                            Type: 'group',
                            Terms: data.Terms
                        } );
                    }
                } );
                if ( json.suggestions.length < 8 ) {
                    jQuery.each( data.Products, function ( intIndex, objElement ) {
                        var isDiscontinuedProduct = objElement.Type === 1,
                            isSingleProduct = data.Products.length === 1; 
                        if ( isDiscontinuedProduct ) {
                            productUrl = dcc.search.discontinuedUrl + '?productid=' + objElement.Id;
                        }
                        else if ( isSingleProduct === true && data.Groups.length > 0 ) {
                            productUrl = dcc.search.viewAllLink + encodeURIComponent( query );
                        } else if(isSingleProduct === true && data.Terms.toLowerCase() !== query.toLowerCase()){
                            productUrl = dcc.search.viewAllLink + encodeURIComponent( data.Terms );
                        }
                        else if ( objElement.Url === '' ) {
                            productUrl = dcc.search.fallbackpage + '?productid=' + objElement.Id;
                        }
                        else {
                            productUrl = objElement.Url;
                        }
                        json.suggestions.push( {
                            Title: objElement.Title,
                            Url: productUrl,
                            Type: 'product',
                            Terms: data.Terms
                        } );
                    } );
                }
                asyncResults( json.suggestions );
            } );
        }
    },
    clear: function () {
        jQuery( '.js-dcc-search-typeahead-input' ).typeahead( 'val', '' );
    },
    setDefault: function () {
        var defaultValue = e4.util.getUrlParameter( 'q' );
        jQuery( '.js-dcc-search-typeahead-input' ).typeahead( 'val', defaultValue );
    },
    select: function ( objSuggestion ) {
        location.assign( objSuggestion.Url );
    }
};
